import React from 'react';
import PageHeader from '../components/PageHeader';
import InstitutionGrid from '../components/InstitutionGrid';
import AuditPromo from '../components/AuditPromo';
import CtaBand from '../components/CtaBand';
import JsonLd from '../components/JsonLd';
import usePageMeta from '../utils/usePageMeta';
import { breadcrumbSchema } from '../utils/schema';

const SolutionsPage = () => {
  usePageMeta(
    'Digital Solutions for Schools, Coaching Institutes, Colleges & Libraries',
    'Websites, ERP, digital marketing, content and more, tailored for schools, coaching institutes, kindergartens, colleges and libraries.'
  );

  return (
    <>
      <JsonLd data={breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Solutions', path: '/solutions' }])} />
      <PageHeader
        eyebrow="Solutions"
        title="Digital solutions for every kind of institute."
        subtitle="Schools, coaching institutes, kindergartens, colleges and libraries each have different needs. Choose yours to see how we help."
      />
      <InstitutionGrid showHead={false} />
      <AuditPromo alt />
      <CtaBand />
    </>
  );
};

export default SolutionsPage;
